import api from './api';

export interface CallHistoryParams {
  start_date?: string;
  end_date?: string;
  extension?: string;
  direction?: string;
  remote_number?: string;
  page?: number;
  per_page?: number;
  customerId?: string | number; // Changed from customer_id to match backend expectation
}

export interface CallHistoryResponse {
  success: boolean;
  data: {
    calls: any[];
    pagination: {
      current_page: number;
      per_page: number;
      total: number;
      total_pages: number;
      from: number;
      to: number;
    };
    filters: {
      start_date: string;
      end_date: string;
      extension: string;
      direction: string;
    };
    statistics: any;
  };
}

export interface ActiveCallsResponse {
  success: boolean;
  data: {
    activeCalls: any[];
    timestamp: string;
  };
}

export interface RecordingUpdateResponse {
  success: boolean;
  data: {
    calls_checked: number;
    recordings_linked: number;
    updated_calls: Array<{
      call_id: number;
      recording_file: string;
    }>;
    message: string;
  };
}

class CallHistoryService {
  async getCallHistory(params: CallHistoryParams): Promise<CallHistoryResponse> {
    const response = await api.get<CallHistoryResponse>('/endpoints/call-history', { params });
    return response.data;
  }

  async getActiveCalls(params?: { customerId?: string | number }): Promise<ActiveCallsResponse> {
    const response = await api.get<ActiveCallsResponse>('/endpoints/active-calls', { params });
    return response.data;
  }
  
  async checkRecordingUpdates(minutes: number = 5): Promise<RecordingUpdateResponse> {
    const response = await api.get<RecordingUpdateResponse>('/endpoints/check-recording-updates', {
      params: { minutes }
    });
    return response.data;
  }
}

const callHistoryService = new CallHistoryService();
export default callHistoryService;